import React, { useState, useMemo } from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppContact: React.FC = () => {
    const [isHovered, setIsHovered] = useState(false);
    const phoneNumber = "9737007989";
    const message = encodeURIComponent("Hello, I'd like to know more about your products.");
    
    const isMobile = useMemo(() => /iPhone|iPad|iPod|Android/i.test(navigator.userAgent), []);
    const link = isMobile 
        ? `whatsapp://send?phone=${phoneNumber}&text=${message}` 
        : `https://wa.me/${phoneNumber}?text=${message}`;

    const handleClick = () => {
        window.open(link, '_blank');
    };

    return (
        <div 
            onClick={handleClick}
            aria-label="Contact us on WhatsApp"
            style={{
                position: 'fixed',
                bottom: '20px',
                right: '20px',
                zIndex: 1000,
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#25D366',
                color: 'white',
                borderRadius: '50px',
                padding: '10px 15px',
                cursor: 'pointer',
                boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                transition: 'transform 0.3s ease',
                transform: isHovered ? 'scale(1.05)' : 'scale(1)'
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <FaWhatsapp style={{ fontSize: '24px', marginRight: '8px' }} />
            <span style={{ fontWeight: 600, fontSize: '15px' }}>Get in touch</span>
        </div>
    );
};

export default WhatsAppContact;

